<template>
  <v-hover v-slot="{ isHovering, props }">
    <div
      v-bind="props"
      class="legend-item"
      :class="{ 'legend-item-hover': legendToggleEnabled && isHovering }"
    >
      <div
        class="legend-item-label"
      >
        <div
          v-if="!legendItem.image"
          class="
        legend-item-label-square"
          :style="getSquareStyle(legendItem)"
        />
        <canvas
          v-else
          ref="legendItemCanvas"
          height="20"
          width="20"
          style="padding-left: 0px; margin-top: 1px;"
        />
        <label
          class="legend-item-text"
          :class="{'legend-item-text-opaque': !legendItem.visible}"
        >
          {{ legendItem.label }}
        </label>
      </div>
      <v-btn
        v-if="legendToggleEnabled"
        :icon="legendItem.visible ? `mdi-eye-outline` : `mdi-eye-off-outline`"
        variant="text"
        class="legend-item-icon"
        :style="(isHovering || !legendItem.visible) ? 'visibility: visible' : 'visibility: hidden'"
        @click="$emit('toggle-item-visibility', legendItem.uid, !legendItem.visible)"
      />
    </div>
  </v-hover>
</template>

<script lang="ts">
import {LegendItem} from '@/lib/classes/Legend/LegendItem';
import {PropType} from 'vue';

export default {
  name: 'LegendItem',
  props: {
    legendItem: {
      type: Object as PropType<LegendItem>,
      required: true,
    },
    legendToggleEnabled: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['toggle-item-visibility'],
  mounted() {
    this.drawToCanvas();
  },
  methods: {
    getSquareStyle(legendItem: LegendItem) {
      return `
        background-color: ${legendItem.fillColor};
        border: 2px solid ${legendItem.strokeColor};
      `;
    },
    drawToCanvas() {
      if (!this.legendItem.image) return;
      const canvas = this.$refs.legendItemCanvas as HTMLCanvasElement;
      const ctx = canvas.getContext('2d');
      if (!ctx) return;
      const opts = this.legendItem.imageOpts;
      ctx.drawImage(
        this.legendItem.image!,
        opts!.offsetX,
        opts!.offsetY,
        opts!.width,
        opts!.height,
        0,
        0,
        // Using opts will allow for variable sizes
        canvas.width,
        // opts!.width,
        canvas.height,
        // opts!.height,
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.legend-item {
  min-height: 26px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  &-hover {
    cursor: pointer;
    background-color: main.$lightGray;
  }

  &-label {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;

    &-square {
      background-color: black;
      min-width: 15px;
      min-height: 15px;
      margin-right: 5px;
      margin-top: 3px;
    }
  }
  &-text {
    font-family: main.$fontPrimary;
    color: #666;
    font-weight: 500;
    cursor: pointer;

    &-opaque {
      opacity: 0.5;
    }
  }
  &-icon {
    max-height: 26px;
    max-width: 26px;
    padding: 0px;
    padding-top: 2px;

    :deep(i) {
      font-size: 21px;
    }

    // make the hover background larger than the button itself
    &:hover {
      :deep(.v-btn__overlay) {
        background-color: main.$midGray;
        opacity: 100%;
        top: -2px;
        left: -3px;
        width: 120%;
        height: 120%;
      }
    }
  }
}
</style>
